export default __webpack_public_path__ + "static/media/redSky.e31e0960.jpeg";